
export enum LoadType
{
    PRODUCT,
    SEARCH,
    TUBE,
}